import React from 'react';
import {Box} from '@mui/material';
import CreateCardApp from "../../../../Cards/Functionality/CreateCardApp";
import CustomModal from "../../../../../components/Modal/CustomModal";
import CustomDescriptionLabel from "../../../../../components/CustomDescriptionLabel";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomCheckbox} from "../../../../../components/CustomCheckbox";
import {CustomSelect} from "../../../../../components/CustomSelect";
import {FORMAT_DATA} from "../../../Controller/Formats/Model/Models";

const AddCardModal = (props) => {
    const { open, onHide} = props;
    const {
        t,
        emptyFields,
        facilityCode,
        setFacilityCode,
        addRange,
        setAddRange,
        number,
        setNumber,
        startingIn,
        setStartingIn,
        validStarting,
        endingIn,
        setEndingIn,
        validEnding,
        format,
        setFormat,
        getAllCardFormats,
        isValidFacilityCode,
        setIsValidFacilityCode,
        handleConfirm,
        validateStarting,
        validateEnding,
    } = CreateCardApp(props);

    return (
        <CustomModal
            title={"create"}
            show={open}
            size="lg"
            buttonConfirm="create"
            cancelButton={true}
            confirmButton={true}
            onConfirm={handleConfirm}
            onHide={onHide}
            classNameBody="pt-2"
        >


            <div className={"row"}>
                <div className={"col-12 center-text"}>
                    <CustomDescriptionLabel trans={t('fill_out_all_the_card_data')}/>
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomTextField id={"txt_acm_facility_code"}
                                     length={3}
                                     name={"facilityCode"}
                                     value={facilityCode}
                                     trans={"facility_code"}
                                     type={"number"}
                                     onChange={(e) => {
                                         if(FORMAT_DATA.isValidFacilityCode(e.target.value)) setIsValidFacilityCode(false);
                                         else setIsValidFacilityCode(true);
                                         setFacilityCode(e.target.value);
                                     }}
                                     required={true}
                                     emptyFields={emptyFields}
                                     helperText={"must_be_less_than_or_equal_to_255"}
                                     isValid={isValidFacilityCode}
                                     isValidText={"must_be_less_than_or_equal_to_255"}
                    />
                </div>
                <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomCheckbox id={"cb_adm_add_range"}
                                    trans={"add_range"}
                                    name={"addRange"}
                                    checked={addRange}
                                    value={addRange}
                                    onChange={(e) =>  setAddRange(!addRange)}
                    />
                </Box>
                {!addRange ? (
                    <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomTextField id={"txt_acm_number"}
                                         length={255}
                                         name={"number"}
                                         value={number}
                                         trans={"number"}
                                         type={"number"}
                                         onChange={(e) => setNumber(e.target.value)}
                                         required={true}
                                         emptyFields={emptyFields}
                        />
                    </Box>
                ) : (
                    <div className={"row m-0 p-0"}>
                        <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                            <CustomTextField id={"txt_acm_starting_in"}
                                             name={"startingIn"}
                                             value={startingIn}
                                             trans={"starting_in"}
                                             type={"number"}
                                             onChange={(e) => {
                                                 const newValue = e.target.value;
                                                 validateStarting(newValue);
                                                 setStartingIn(newValue);
                                             }}
                                             required={true}
                                             emptyFields={emptyFields}
                                             isValid={validStarting}
                                             isValidText={"invalid_number"}
                            />
                        </Box>
                        <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                            <CustomTextField id={"txt_acm_ending_in"}
                                             name={"endingIn"}
                                             value={endingIn}
                                             trans={"ending_in"}
                                             type={"number"}
                                             onChange={(e) => {
                                                 const newValue = e.target.value;
                                                 validateEnding(newValue);
                                                 setEndingIn(newValue);
                                             }}
                                             required={true}
                                             emptyFields={emptyFields}
                                             isValid={validEnding}
                                             isValidText={"invalid_number"}
                            />
                        </Box>
                    </div>
                )}

                <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomSelect id={"slt_acm_format"}
                                  name={"format"}
                                  value={format}
                                  keyName="id"
                                  onChange={(e) => setFormat(e.target.value) }
                                  list={getAllCardFormats}
                                  trans={"format"}
                                  label={"lbl_acm_format"}
                                  required={true}
                                  emptyFields={emptyFields}
                                  showNoSelectionOption={false}
                    />
                </Box>
            </div>
        </CustomModal>
    );
};

export default AddCardModal;
